export function copyHrefToBuffer() {
    const link = $('.copy-href');

    link.on('click', function (e) {
        e.preventDefault();
        link.addClass('clicked');
        let url = $(this).attr('href');
        let temp = $("<input>");
        $("body").append(temp);
        temp.val(url).select();
        document.execCommand("copy");
        temp.remove();
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/copyHrefToBuffer.js